import React from 'react';
import Button from '../atoms/Button';

export default function AddTableCard({ level, onAdd }) {
  const title = `Level ${level}`;
  const subtitle = level === 1
    ? 'Initial Handler'
    : level === 2
      ? 'Escalation if L1 TAT exceeded'
      : 'Escalation workflow';

  return (
    <div className="ca-add-table-card">
      <header className="ca-add-table-card__header">
        <span className="ca-add-table-card__level">L{level}</span>
        <div className="ca-add-table-card__header-text">
          <h3 className="ca-add-table-card__title">{title}</h3>
          <p className="ca-add-table-card__subtitle">{subtitle}</p>
        </div>
      </header>
      <div className="ca-add-table-card__action">
        <Button
          type="button"
          className="ca-add-table-card__button"
          onClick={() => onAdd?.(title)}
        >
          + Add L{level}
        </Button>
      </div>
    </div>
  );
}
